/* Revolv footer ride: a bike that grows while it rides along the bottom line.
   Drawing style: child's colouring page. Cream outlines, flat Frog colours laid slightly outside the lines.
   RVRide.build(host, labels, scale) creates the stage SVGs; RVRide.frame(state, t, T, endX, startX) positions everything at time t (seconds). */
(function (w) {
  var STAGES = [
    { r: 13, k: 'balance', c: '#E27DAE' }, { r: 15, k: 'pedal', c: '#5DB356' }, { r: 17.5, k: 'pedal', c: '#EE8A2A' },
    { r: 21.5, k: 'pedal', c: '#3B7BCB' }, { r: 25.5, k: 'gears', c: '#EFC235' }, { r: 28, k: 'gears', c: '#2AAFAC' }
  ];
  var LINE = '#F3F2F0', PAPER = '#203838', TYRE = '#0F1515', METAL = '#C3CCCA', DARK = '#0F1515';
  var OW = 0.8, CW = 1.22, COL_OP = 0.95;
  var uid = 0;

  function f(n) { return Math.round(n * 10) / 10; }
  function rnd(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  /* geometry helpers: every item is a list of points, sampled about every 4px */
  function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
  function dist(a, b) { return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1])); }
  function nOf(len) { return Math.max(2, Math.ceil(len / 4)); }
  function seg(a, b) { var n = nOf(dist(a, b)), o = []; for (var i = 0; i <= n; i++) o.push(lerp(a, b, i / n)); return o; }
  function quad(a, c, b) {
    var n = nOf(dist(a, c) + dist(c, b)), o = [];
    for (var i = 0; i <= n; i++) { var t = i / n; o.push(lerp(lerp(a, c, t), lerp(c, b, t), t)); }
    return o;
  }
  function cubic(a, c1, c2, b) {
    var n = nOf(dist(a, c1) + dist(c1, c2) + dist(c2, b)), o = [];
    for (var i = 0; i <= n; i++) {
      var t = i / n, u = 1 - t;
      o.push([u * u * u * a[0] + 3 * u * u * t * c1[0] + 3 * u * t * t * c2[0] + t * t * t * b[0], u * u * u * a[1] + 3 * u * u * t * c1[1] + 3 * u * t * t * c2[1] + t * t * t * b[1]]);
    }
    return o;
  }
  function circ(cx, cy, r) {
    var n = Math.max(10, Math.ceil(2 * Math.PI * r / 4)), o = [];
    for (var i = 0; i < n; i++) { var a = i / n * 2 * Math.PI; o.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]); }
    return o;
  }
  function poly() { var o = []; for (var i = 0; i < arguments.length; i++) { var p = arguments[i]; o = o.concat(o.length ? p.slice(1) : p); } return o; }

  /* hand wobble: move each point along the normal with two slow sine waves */
  function wobble(it, A, la, lb, rng) {
    var p = it.p, n = p.length, closed = it.z, u = [0], i;
    for (i = 1; i < n; i++) u.push(u[i - 1] + dist(p[i - 1], p[i]));
    var len = u[n - 1] + (closed ? dist(p[n - 1], p[0]) : 0);
    if (closed) { la = len / Math.max(1, Math.round(len / la)); lb = len / Math.max(1, Math.round(len / lb)); }
    var p1 = rng() * 6.28, p2 = rng() * 6.28, o = [];
    for (i = 0; i < n; i++) {
      var a = p[closed ? (i - 1 + n) % n : Math.max(0, i - 1)], b = p[closed ? (i + 1) % n : Math.min(n - 1, i + 1)];
      var dx = b[0] - a[0], dy = b[1] - a[1], dl = Math.sqrt(dx * dx + dy * dy) || 1;
      var off = A * (0.65 * Math.sin(6.2832 * u[i] / la + p1) + 0.35 * Math.sin(6.2832 * u[i] / lb + p2));
      o.push([p[i][0] - dy / dl * off, p[i][1] + dx / dl * off]);
    }
    return { p: o, z: closed, w: it.w, fill: it.fill };
  }

  /* smooth path through the points (Catmull-Rom as cubic Bezier) */
  function d(it, dx, dy) {
    var p = it.p, n = p.length, z = it.z, s = 'M' + f(p[0][0] + dx) + ' ' + f(p[0][1] + dy);
    function at(i) { if (z) return p[(i + n) % n]; return p[Math.max(0, Math.min(n - 1, i))]; }
    var last = z ? n : n - 1;
    for (var i = 0; i < last; i++) {
      var p0 = at(i - 1), p1 = at(i), p2 = at(i + 1), p3 = at(i + 2);
      s += 'C' + f(p1[0] + (p2[0] - p0[0]) / 6 + dx) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6 + dy) + ' ' +
        f(p2[0] - (p3[0] - p1[0]) / 6 + dx) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6 + dy) + ' ' + f(p2[0] + dx) + ' ' + f(p2[1] + dy);
    }
    return s + (z ? 'Z' : '');
  }

  /* one colourable part: paper underneath, colour a bit off the lines, then the cream outline on top */
  function part(items, col, rng, k, defs) {
    var id = 'rvm' + (++uid), mask = '', paper = '', color = '', line = '';
    var ox = f(1.4 * k), oy = f(-1.1 * k);
    items.forEach(function (it) {
      var o = wobble(it, 0.4 * k, 16, 7, rng), c = wobble(it, 1.2 * k, 22, 9, rng);
      var od = d(o, 0, 0), cd = d(c, ox, oy), pid = 'rvp' + (++uid);
      defs.push('<path id="' + pid + '" d="' + od + '"/>');
      var wide = it.fill ? 'fill="%" stroke="%" stroke-width="' + f(2 * OW) + '"' : 'fill="none" stroke="%" stroke-width="' + f(it.w + 2 * OW) + '"';
      var inner = it.fill ? 'fill="%" stroke="none"' : 'fill="none" stroke="%" stroke-width="' + f(it.w) + '"';
      mask += '<use href="#' + pid + '" ' + wide.replace(/%/g, '#fff') + '/>';
      paper += '<use href="#' + pid + '" ' + wide.replace(/%/g, PAPER) + '/>';
      line += '<use href="#' + pid + '" ' + wide.replace(/%/g, LINE) + '/>';
      mask += '<use href="#' + pid + '" ' + inner.replace(/%/g, '#000') + '/>';
      color += it.fill ? '<path d="' + cd + '" fill="' + col + '" stroke="' + col + '" stroke-width="' + f(2 * OW * CW) + '"/>'
        : '<path d="' + cd + '" fill="none" stroke="' + col + '" stroke-width="' + f(it.w * CW + OW * (CW - 1) * 2) + '"/>';
    });
    defs.push('<mask id="' + id + '" maskUnits="userSpaceOnUse" x="-200" y="-200" width="600" height="400">' + mask + '</mask>');
    return paper + (col ? '<g opacity="' + COL_OP + '">' + color + '</g>' : '') + '<g mask="url(#' + id + ')">' + line + '</g>';
  }
  function lines(list) {
    return list.map(function (l) {
      return '<path d="' + d(l, 0, 0) + '" fill="none" stroke="' + LINE + '" stroke-width="' + f(l.w) + '" opacity="' + l.op + '"' + (l.dash ? ' stroke-dasharray="' + l.dash + '"' : '') + '/>';
    }).join('');
  }

  function svg(st, idx, k) {
    var s = st.r * k, kind = st.k, L = 3.1 * s, t = 0.2 * s, pad = 2;
    var top = 2.05 * s + pad, W = L + 2 * (s + OW) + 2 * pad, H = top + s + OW + 1;
    var ox = s + OW + pad, oy = top, rng = rnd(97 + idx * 131), defs = [];
    var BB = [0.43 * L, 0.12 * s];
    var S = kind === 'balance' ? [0.36 * L, -1.0 * s] : [0.34 * L, -1.15 * s];
    var Ht = [0.85 * L, -1.3 * s], Hb = [0.88 * L, -0.88 * s];
    var Pp = [S[0] - 0.05 * s, -1.62 * s], St = [0.83 * L, -1.72 * s], G = [St[0] - 0.32 * s, -1.8 * s];
    var fw = Math.max(2.6, 0.15 * s), mw = Math.max(1.7, 0.085 * s), thin = Math.max(0.8, 0.045 * s);
    var art = '', back = '', front = '', wheels = [];

    // wheels: tyre and hub are drawn, the spokes go to the layer behind so they can turn
    [0, L].forEach(function (cx, wi) {
      art += part([{ p: circ(cx, 0, s - t / 2), z: 1, w: t }], TYRE, rng, k, defs);
      art += lines([{ p: circ(cx, 0, s - t - 0.3), z: 1, w: Math.max(0.7, 0.04 * s), op: 0.9 }]);
      art += part([{ p: circ(cx, 0, 0.1 * s), z: 1, w: 0.12 * s }], METAL, rng, k, defs);
      var sp = '';
      for (var i = 0; i < 14; i++) {
        var a = (i * 360 / 14 + (wi ? 8 : 0)) * Math.PI / 180;
        sp += 'M' + f(cx + Math.cos(a) * 0.13 * s) + ' ' + f(Math.sin(a) * 0.13 * s) + 'L' + f(cx + Math.cos(a + 0.35) * (s - t - 0.4)) + ' ' + f(Math.sin(a + 0.35) * (s - t - 0.4));
      }
      back += '<g data-cx="' + f(cx) + '"><path d="' + sp + '" stroke="' + LINE + '" stroke-width="' + f(Math.max(0.45, 0.025 * s)) + '" opacity=".5"/></g>';
      wheels.push(f(cx));
    });
    // chain and rear gear
    if (kind !== 'balance') {
      var cr = 0.33 * s, cog = kind === 'gears' ? 0.22 * s : 0.15 * s, cw = Math.max(0.6, 0.035 * s), dash = f(0.08 * s) + ' ' + f(0.05 * s);
      art += lines([{ p: seg([BB[0], BB[1] - cr], [0, -cog]), w: cw, op: 0.85, dash: dash }, { p: seg([BB[0], BB[1] + cr], [0, cog]), w: cw, op: 0.85, dash: dash }, { p: circ(0, 0, cog), z: 1, w: cw, op: 0.85 }]);
      if (kind === 'gears') art += lines([{ p: poly(seg([0.04 * s, 0.2 * s], [0.12 * s, 0.48 * s]), seg([0.12 * s, 0.48 * s], [0.02 * s, 0.56 * s])), w: Math.max(0.7, 0.04 * s), op: 0.9 }]);
    }
    // frame, head tube and fork share one outline
    var frame = kind === 'balance'
      ? [{ p: seg([0, 0], S), w: fw }, { p: seg([S[0] - 0.12 * s, S[1] + 0.08 * s], [Ht[0], Ht[1] + 0.12 * s]), w: fw }, { p: quad([0.1 * s, -0.12 * s], [0.45 * L, -0.25 * s], Hb), w: fw }]
      : [{ p: poly(seg([0, 0], BB), seg(BB, S), seg(S, [0, 0])), w: fw }, { p: seg(S, Ht), w: fw }, { p: seg(BB, Hb), w: fw }];
    frame.push({ p: seg(Ht, Hb), w: fw * 1.3 }, { p: quad(Hb, [L - 0.1 * s, -0.25 * s], [L + 0.02 * s, 0]), w: fw * 0.85 });
    art += part(frame, st.c, rng, k, defs);
    // seat post, stem and riser bar
    art += part([{ p: seg([S[0], S[1] - fw * 0.3], Pp), w: mw }, { p: poly(seg([Ht[0], Ht[1] - fw * 0.3], St), quad(St, [St[0] - 0.05 * s, G[1] + 0.02 * s], G)), w: mw * 0.9 }], METAL, rng, k, defs);
    // brakes and brake lever
    art += lines([{ p: seg([0.2 * s, -0.98 * s], [0.32 * s, -0.84 * s]), w: thin, op: 0.95 }, { p: seg([L - 0.18 * s, -0.98 * s], [L - 0.28 * s, -0.82 * s]), w: thin, op: 0.95 },
      { p: seg([G[0] + 0.3 * s, G[1] + 0.06 * s], [G[0] + 0.62 * s, G[1] + 0.22 * s]), w: thin, op: 0.95 }]);
    // grip
    art += part([{ p: seg([G[0] + 0.02 * s, G[1]], [G[0] + 0.3 * s, G[1] + 0.03 * s]), w: Math.max(2.2, 0.13 * s) }], DARK, rng, k, defs);
    // saddle
    var sx = Pp[0], sy = Pp[1] - 0.02 * s, q = 1.1;
    var sad = poly(cubic([sx - 0.5 * q * s, sy - 0.02 * s], [sx - 0.5 * q * s, sy - 0.22 * s], [sx + 0.1 * s, sy - 0.18 * s], [sx + 0.52 * q * s, sy - 0.07 * s]),
      cubic([sx + 0.52 * q * s, sy - 0.07 * s], [sx + 0.6 * q * s, sy - 0.02 * s], [sx + 0.3 * s, sy + 0.08 * s], [sx - 0.1 * s, sy + 0.08 * s]),
      cubic([sx - 0.1 * s, sy + 0.08 * s], [sx - 0.4 * s, sy + 0.1 * s], [sx - 0.54 * q * s, sy + 0.06 * s], [sx - 0.5 * q * s, sy - 0.02 * s]));
    sad.pop();
    art += part([{ p: sad, z: 1, fill: 1 }], DARK, rng, k, defs);
    // chainring, then crank and pedal on the front layer so they can turn
    var crank = null;
    if (kind !== 'balance') {
      var pe = [BB[0] + 0.1 * s, BB[1] + 0.48 * s], pw = 0.17 * s;
      art += part([{ p: circ(BB[0], BB[1], 0.33 * s * 0.82), z: 1, w: 0.33 * s * 0.36 }], METAL, rng, k, defs);
      front = '<g class="rvr-crank">' + part([{ p: seg(BB, pe), w: Math.max(1.4, 0.075 * s) }], DARK, rng, k, defs) +
        '<g class="rvr-pedal">' + part([{ p: seg([pe[0] - pw, pe[1]], [pe[0] + pw, pe[1]]), w: Math.max(1.8, 0.1 * s) }], DARK, rng, k, defs) + '</g></g>';
      crank = { bb: BB, pe: pe };
    }
    function box(cls, style, body, withDefs) {
      return '<svg class="' + cls + '" style="' + style + '" width="' + f(W) + '" height="' + f(H) + '" viewBox="0 0 ' + f(W) + ' ' + f(H) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        (withDefs ? '<defs>' + defs.join('') + '</defs>' : '') + '<g transform="translate(' + f(ox) + ' ' + f(oy) + ')">' + body + '</g></svg>';
    }
    return {
      w: W, h: H, wheels: wheels, crank: crank,
      html: box('rvr-ov', 'position:absolute;left:0;top:0;z-index:0', back) +
        box('rvr-art', 'position:relative;z-index:1;display:block;will-change:transform', art, true) +
        (front ? box('rvr-ov', 'position:absolute;left:0;top:0;z-index:2', front) : '')
    };
  }
  function build(host, labels, k) {
    var st = { host: host, bikes: [], tag: null, ink: host.querySelector('.rvr-ink'), rider: host.querySelector('.rvr-rider') };
    k = k || 1;
    STAGES.forEach(function (s, i) {
      var o = svg(s, i, k), el = document.createElement('div');
      el.className = 'rvr-bike'; el.style.width = f(o.w) + 'px'; el.style.marginLeft = f(-o.w / 2) + 'px';
      el.innerHTML = o.html; st.rider.appendChild(el);
      var b = { el: el, w: o.w, h: o.h, r: s.r * k, crank: o.crank, spokes: [], cg: el.querySelector('.rvr-crank'), pg: el.querySelector('.rvr-pedal') };
      Array.prototype.forEach.call(el.querySelectorAll('[data-cx]'), function (g) { b.spokes.push({ g: g, cx: g.getAttribute('data-cx') }); });
      st.bikes.push(b);
    });
    var tag = document.createElement('span'); tag.className = 'rvr-tag'; st.rider.appendChild(tag); st.tag = tag;
    st.rider.style.willChange = 'transform';
    st.labels = labels;
    return st;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function turn(b, rot) {
    b.spokes.forEach(function (w) { w.g.setAttribute('transform', 'rotate(' + f(rot) + ' ' + w.cx + ' 0)'); });
    if (b.cg && b.crank) {
      var c = rot * 0.55, bb = b.crank.bb, pe = b.crank.pe;
      b.cg.setAttribute('transform', 'rotate(' + f(c) + ' ' + f(bb[0]) + ' ' + f(bb[1]) + ')');
      b.pg.setAttribute('transform', 'rotate(' + f(-c) + ' ' + f(pe[0]) + ' ' + f(pe[1]) + ')');
    }
  }
  function frame(st, t, T, endX, sx) {
    var n = st.bikes.length, p = clamp(t / T, 0, 1);
    // constant cruising speed with a soft start and a soft stop
    var e, a = 0.08;
    if (p < a) e = (p * p) / (2 * a * (1 - a));
    else if (p > 1 - a) e = 1 - Math.pow(1 - p, 2) / (2 * a * (1 - a));
    else e = (p - a / 2) / (1 - a);
    var w0 = st.bikes[0].w, startX = (sx === undefined ? -w0 : sx), x = startX + (endX - startX) * e;
    st.rider.style.transform = 'translateX(' + f(x) + 'px)';
    // stages are spread over the visible part of the ride: the first one starts once the balance bike is fully on screen
    var xa = startX + 1.5 * w0 + 10;
    var sf = endX > xa ? clamp((x - xa) / (endX - xa) * n, 0, n - 0.0001) : n - 0.0001, k = Math.floor(sf), d = sf - k, fade = 0.1;
    st.bikes.forEach(function (b, i) {
      var o = 0, hop = 0;
      if (i === k) { o = (i > 0 && d < fade) ? d / fade : 1; if (i > 0 && d < 0.2) hop = -Math.sin(d / 0.2 * Math.PI) * 6; }
      if (i === k - 1 && d < fade) o = 1 - d / fade;
      if (p >= 1) o = i === n - 1 ? 1 : 0;
      b.el.style.opacity = o; b.el.style.transform = 'translateY(' + f(hop) + 'px)';
      if (o > 0) turn(b, x / b.r * 57.3);
    });
    var cur = st.bikes[k];
    if (st.ink) st.ink.style.width = Math.max(0, x - cur.w / 2 + 2) + 'px';
    if (st.tag && st.labels) {
      st.tag.textContent = st.labels[k] || '';
      st.tag.style.opacity = p < 1 ? clamp(Math.sin(d * Math.PI) * 1.8, 0, 1) : 0;
      st.tag.style.transform = 'translate(-50%,' + f(-(cur.h + 14)) + 'px)';
    }
    return p >= 1;
  }
  w.RVRide = { build: build, frame: frame, count: STAGES.length };
})(window);

/* Start the ride when the bottom of the footer comes into view, once per visit.
   Reduced motion or already seen in this visit: the bike is shown parked. Hovering the parked bike replays it. */
(function () {
  function init() {
    var host = document.querySelector('.rvf__ride');
    if (!host || host.getAttribute('data-ready')) return;
    host.setAttribute('data-ready', '1');
    host.classList.add('is-ready'); // show the line first so its width can be measured
    var root = host.closest('.rvf') || document.body;
    var labels = (host.getAttribute('data-labels') || '').split('|');
    var st = RVRide.build(host, labels, 0.8);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var running = false, key = 'rvf-ride-seen';
    function chatBtn() {
      var c = document.querySelector('shopify-chat'), b = c && c.shadowRoot && c.shadowRoot.querySelector('.activator');
      if (!b) return null;
      var r = b.getBoundingClientRect();
      return r.width && r.height ? r : null;
    }
    function endX() {
      var w = host.clientWidth, big = st.bikes[st.bikes.length - 1].w, x = w - big / 2 - 4;
      var hr = host.getBoundingClientRect(), chat = window.innerWidth >= 768 ? chatBtn() : null;
      if (chat) return Math.min(chat.left - hr.left - big / 2 - 12, w - big / 2 + 60); // stops right before the chat bubble
      var lang = root.querySelector('.rvf__lang');
      if (lang && window.innerWidth >= 1024) {
        var lr = lang.getBoundingClientRect();
        if (lr.width) x = Math.min(x, lr.left - hr.left - big / 2 - 28);
      }
      return x;
    }
    function startX() { return -(host.getBoundingClientRect().left + st.bikes[0].w); }
    function park() { RVRide.frame(st, 1, 1, endX()); }
    function play() {
      if (running) return;
      running = true;
      var T = host.clientWidth > 700 ? 12 : 9, ex = endX(), sx = startX(), t0 = null;
      parked = true;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var done = RVRide.frame(st, (ts - t0) / 1000, T, ex, sx);
        if (done) running = false; else window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
    var seen = false;
    try { seen = window.sessionStorage.getItem(key) === '1'; } catch (e) {}
    var parked = reduce || seen || !('IntersectionObserver' in window);
    if (parked) {
      park();
    } else {
      RVRide.frame(st, 0, 1, endX(), startX());
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        try { window.sessionStorage.setItem(key, '1'); } catch (e) {}
        play();
      }, { threshold: 0.5 });
      io.observe(host.parentNode);
    }
    var tries = 0;
    (function waitChat() {
      if (chatBtn()) { if (parked && !running) park(); return; }
      if (++tries < 12) setTimeout(waitChat, 700);
    })();
    st.rider.addEventListener('mouseenter', function () { if (!reduce && !running) play(); });
    window.addEventListener('resize', function () { if (!running) park(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
